import { render, staticRenderFns } from "./NewsDeleteModal.vue?vue&type=template&id=4ab3f332&scoped=true&"
import script from "./NewsDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./NewsDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab3f332",
  null
  
)

export default component.exports